export default __webpack_public_path__ + "static/media/0231.8fe37915.jpg";